module.exports = __webpack_public_path__ + "img/banner-fale-conosco.532842a2.jpg";